import { render, staticRenderFns } from "./ChartFilterButton.vue?vue&type=template&id=87d315c8"
import script from "./ChartFilterButton.vue?vue&type=script&lang=js"
export * from "./ChartFilterButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports